<template>
    <v-layout row pr-2>
        <v-flex md2 xs2 pt-2>
            <v-icon>{{icon}}</v-icon>
        </v-flex>
        <v-flex md6 xs6 pt-2>
            {{description}}
        </v-flex>
        <v-flex md2 xs2 pt-2>
            <div class="pl-2 number-of-passenger">{{count}}</div>
        </v-flex>       
 
  
        <v-flex md1 xs1 mr-2>
            <v-btn flat icon small @click="removePassenger()">
                <v-icon>remove_circle_outline</v-icon>
            </v-btn>
        </v-flex>   
        <v-flex md1 xs1>
            <v-btn flat icon small @click="addPassenger()">
                <v-icon>add_circle_outline</v-icon>
            </v-btn>
        </v-flex>                                                                                                                                                     
    </v-layout>
</template>

<script>
export default {
    created(){
        if (this.setCount!=null){
            this.count = this.setCount;
            this.getPassengerCount();
        }
    },
    props:['Icon','Description','setCount'],
    data(){
        return {
            icon:this.Icon,
            description:this.Description,
            count:0
        }
    },
    computed:{

    },
    methods:{
        addPassenger(){
            this.count++;
            this.$emit('passengerCount',this.count);
        },
        removePassenger(){
            if (this.count>0) this.count--;
            this.$emit('passengerCount',this.count);
        },
        getPassengerCount(){
            this.$emit('passengerCount',this.count);
        }
    }
}
</script>

<style>
.number-of-passenger{
    width:100%;
    text-align: center;
}
</style>
